import PatientCard from "../../components/PaitientCard/PatientCard";
import PillNav from "../../components/PillNav/PillNav";
import PrescriptionCard from "../../components/PrescriptionCard/PrescriptionCard";
import Room from "../../components/VideoConf/Room";
import "../../components/VideoCall/VideoCall.scss";
import "./TeleConsolePatient.scss";

const TeleConsolePatient = () => {
return (
<>
  <div style={{paddingTop:"10px !important",position: "relative"}}>
  <div class="container">
    <div class="row">
        <div class="col-8">
              <div class="table-responsive screen3-timer">
                <img src="/img/Path 47771.svg" alt="clock icon" />
                <span class="screen3-appointment-time">
                  Next appointment is in 25 mins
                </span>
                <button class="screen3-check-schedule-button">Check Schdule</button>
              </div>
          </div>
      </div>
    
    <div class="row" style={{height:"600px !important"}}>
      
      <div class="col-sm-6 col-md-8 col-lg-9">
      <div class="screen5-webrtc" style={{height:"600px !important"}}>
      
        <Room />
      </div>
        
      </div> 
      <div class="col-sm-6 col-md-4 col-lg-3">
     
        <div className="patient-chat">
          <div className="patient-chat-content">
            <p className="chat-message">
              It was popularised in the 1960s with the release.
            </p>
            <p className="chat-time">11:59</p>
          </div>
          <img src="/img/Patient-face.png" className="patient-chat-photo" />
        </div>
        <div className="doctor-chat">
          <img src="/img/Patient-face.png" className="doctor-chat-photo" />
          <div className="doctor-chat-content">
            <p className="chat-message">
              Various versions have evolved over the years, some.
            </p>
            <p className="chat-time">11:59</p>
          </div>
        </div>
        <div className="chat-message-container">
          <input
            type="text"
            className="chat-message-input"
            placeholder="Type here to search"
          />
          <button type="button" className="chat-message-input-attachment">
            <img
              src="/img/Path 47773.svg"
              alt="chat attachment button"
              width="20"
              height="20"
            />
          </button>
          <button type="submit" className="chat-message-input-submit">
            <img
              src="/img/direction-top-right.svg"
              alt="chat send button"
              width="20"
              height="20"
            />
          </button>
        </div>
      
      </div>
    </div> 
    </div>
    </div>
  
</>
);
};

export default TeleConsolePatient;
